import dynamic from 'next/dynamic';
import { MemberInformationProps } from './MemberInformation.types';
import { UserInformationProps } from './V2/index.types';

export const MemberInformation = dynamic<MemberInformationProps>(() => import('./MemberInformation'));

export const MemberInformationV2 = dynamic<UserInformationProps>(() =>
  import('./V2').then(module => module.MemberInformationV2)
);
